import type {
  ApiWorkoutFeedbackComment,
  UiWorkoutFeedbackComment,
} from '../types/workoutFeedbackComments.types';

export function mapWorkoutFeedbackCommentFromApi(
  comment: ApiWorkoutFeedbackComment,
): UiWorkoutFeedbackComment {
  return { ...comment, createdAt: new Date(comment.createdAt) };
}
